import styled from "styled-components";

export const WaitingRoomWrapper = styled.section`
  background: #f2f2f2;
  padding: 12px 0 32px;
  min-height: calc(100vh - 120px);
  font-family: "Saira Semi Condensed", sans-serif;
`;

export const WaitingHeader = styled.div`
  max-width: 1100px;
  margin: 0 auto 16px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
  }
  .return-link {
    background: none;
    border: none;
    color: #1a5fff;
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const WaitingCard = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  padding: 18px 20px 24px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  .intro {
    color: #5b6675;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 18px;
  }
  position: relative;
  .waiting-loading {
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 24px 32px;
    z-index: 5;
    border-radius: 10px;
  }
  .waiting-title {
    font-size: 22px;
    font-weight: 700;
    color: #0f172a;
  }
  .waiting-finished {
    min-height: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 26px;
  }
  .waiting-finished h2 {
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    color: #0f172a;
  }
  .waiting-finished p {
    margin: 0;
    font-size: 15px;
    color: #5b6675;
  }
  .waiting-finished .divider {
    width: 100%;
    max-width: 430px;
    height: 1px;
    background: rgb(203, 204, 206);
  }
  .waiting-finished .home-copy {
    color: #101418;
    font-size: 20px;
    font-weight: 400;
  }
  .waiting-finished .home-link {
    border: none;
    background: transparent;
    color: #007aff;
    font: inherit;
    cursor: pointer;
    padding: 0;
  }
`;

export const WaitingMeta = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 220px;
  gap: 20px;
  align-items: center;
  background: #f6f7f9;
  padding: 16px 20px;
  border-radius: 8px;
  .meta-col {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .meta-col.center {
    align-items: center;
    border-left: 1px solid #e1e5ea;
    border-right: 1px solid #e1e5ea;
    padding: 0 20px;
  }
  .meta-col.action {
    align-items: center;
    justify-content: center;
  }
  .meta-row {
    display: flex;
    gap: 6px;
    font-size: 14px;
  }
  .label {
    color: #5b6675;
    font-weight: 600;
  }
  .value {
    color: #101418;
    font-weight: 600;
  }
  .starts {
    color: #5b6675;
    font-size: 13px;
    margin-bottom: 6px;
    text-align: center;
  }
  .draft-open {
    color: #d00000;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }
  @media only screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    .meta-col.center {
      border-left: none;
      border-right: none;
      padding: 12px 0;
    }
    .meta-col.action {
      align-items: flex-start;
    }
  }
`;

export const Countdown = styled.div`
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #1f2937;
`;

export const JoinButton = styled.button`
  background: #3870e0;
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  &:disabled {
    background: #b9c0c8;
    color: #f5f6f8;
    cursor: not-allowed;
  }
`;

export const TableWrap = styled.div`
  margin-top: 20px;
  .loading {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
`;

export const SlotsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  th,
  td {
    text-align: left;
    padding: 10px 8px;
    border-bottom: none;
  }
  tr {
    border-bottom: 1px solid #e3e6ea;
  }
  tr.available {
    cursor: pointer;
  }
  tr.available:hover {
    background: #f7f9fc;
  }
  th {
    font-size: 12px;
    letter-spacing: 0.4px;
    color: #5b6675;
  }
  .team-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .team-logo {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
  }
  .slot {
    color: #1a5fff;
  }
  tr.selected .slot {
    font-weight: 600;
  }
  tr.occupied .slot {
    color: rgb(108, 109, 111);
  }
`;
